"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _forms = _interopRequireDefault(require("@tailwindcss/forms"));
var _defaultTheme = _interopRequireDefault(require("tailwindcss/defaultTheme"));
var _colors = _interopRequireDefault(require("./colors"));
// extends the default Tailwind config
// https://github.com/tailwindlabs/tailwindcss/blob/master/stubs/defaultConfig.stub.js

const config = {
  purge: ['./src/**/*.js', './src/**/*.tsx'],
  theme: {
    extend: {
      screens: {
        244: '244px',
        350: '350px'
      },
      height: {
        5.5: '22px',
        '30px': '30px',
        18: '4.5rem'
      },
      width: {
        128: '32rem',
        172: '43rem'
      },
      maxWidth: {
        '4/10': '40%'
      },
      borderWidth: {
        0.5: '0.5px'
      }
    },
    colors: {
      transparent: 'transparent',
      current: 'currentColor',
      black: _colors.default.black,
      white: _colors.default.white,
      gray: _colors.default.gray,
      red: _colors.default.red,
      orange: _colors.default.orange,
      yellow: _colors.default.yellow,
      green: _colors.default.green,
      blue: _colors.default.blue,
      pink: _colors.default.pink
    },
    fontFamily: {
      // "proxima-nova" is the font family name used in the linked typekit css file.
      // Other projects may use different font sources which could spell it differently.
      sans: ['proxima-nova', ..._defaultTheme.default.fontFamily.sans]
    },
    fontSize: {
      '8px': ['0.5rem', '0.75rem'],
      '10px': ['0.625rem', '1rem'],
      xs: ['0.75rem', '1rem'],
      sm: ['0.875rem', '1rem'],
      base: ['1rem', '1.75rem'],
      lg: ['1.125rem', '2rem'],
      xl: ['1.25rem', '2rem'],
      '2xl': ['1.5rem', '2rem'],
      '3xl': ['2rem', '2.25rem'],
      '4xl': ['2.5rem', '3rem'],
      '5xl': ['4.5rem', '5rem']
    },
    fontWeight: {
      normal: '400',
      semibold: '600',
      bold: '700'
    }
  },
  variants: {
    extend: {
      backgroundColor: ['active', 'disabled'],
      borderColor: ['disabled'],
      cursor: ['disabled'],
      margin: ['first', 'last'],
      ringColor: ['focus-visible'],
      ringOpacity: ['focus-visible'],
      ringWidth: ['focus-visible'],
      textColor: ['disabled']
    }
  },
  plugins: [(0, _forms.default)({
    strategy: 'class'
  })]
};
var _default = config;
exports.default = _default;